/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S2_P1Inputs */

const tr_onbilgi_s2_p1 = /** @type {(inputs: Onbilgi_S2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel, dijital ortamda sunulan bir SaaS (Hizmet Olarak Yazılım) platformudur. Fiziksel ürün gönderimine konu bir teslim sözü içermez; hizmet, abonelik aktivasyonu ile birlikte anlık olarak erişime açılır.`)
};

const en_onbilgi_s2_p1 = /** @type {(inputs: Onbilgi_S2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel is a SaaS (Software as a Service) platform provided in a digital environment. It contains no delivery promise regarding the shipment of physical goods; the service becomes accessible instantly upon activation of the subscription.`)
};

const de_onbilgi_s2_p1 = /** @type {(inputs: Onbilgi_S2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel ist eine digital bereitgestellte SaaS-Plattform (Software als Dienstleistung). Sie enthält kein Lieferversprechen über den Versand physischer Ware; die Dienstleistung wird mit der Aktivierung des Abonnements sofort zugänglich.`)
};

const ru_onbilgi_s2_p1 = /** @type {(inputs: Onbilgi_S2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel является платформой SaaS (программное обеспечение как услуга), предоставляемой в цифровой среде. Она не содержит обязательства по доставке физических товаров; доступ к услуге открывается мгновенно вместе с активацией подписки.`)
};

/**
* | output |
* | --- |
* | "ShopPanel is a SaaS (Software as a Service) platform provided in a digital environment. It contains no delivery promise regarding the shipment of physical go..." |
*
* @param {Onbilgi_S2_P1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s2_p1 = /** @type {((inputs?: Onbilgi_S2_P1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S2_P1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s2_p1(inputs)
	if (locale === "de") return de_onbilgi_s2_p1(inputs)
	if (locale === "ru") return ru_onbilgi_s2_p1(inputs)
	return tr_onbilgi_s2_p1(inputs)
});